import moment from 'moment-timezone';

//utils function to get keys by value.
export const getKeyByValue = (object, value) => {
	return Object.keys(object).filter((key) => object[key] === value);
};

/**
 * Parse a query string of the format `?user=123&blah=abc` into an object
 * @param {string} search
 * @returns {object}
 */
export function parseQueryString(search) {
	return search
		.slice(1)
		.split('&')
		.reduce((acc, n) => {
			const [key, val] = n.split('=');
			acc[key] = val;
			return acc;
		}, {});
}
// Utils function to get file name from file path.
// TODO: explore a library for this functionality.
export const extractFileNameFromPath = (path) => {
	let fileNameWithOutFolder = path.substring(path.indexOf('/') + 1, path.length);
	return fileNameWithOutFolder.slice(0, fileNameWithOutFolder.lastIndexOf('.'));
};
// below utils function format bytes.
export const formatBytes = (bytes, decimals = 2) => {
	// handle negative bytes case (when artifact size is greater than source file).
	if (bytes === 0 || bytes < 0) return '0 Byte';
	const k = 1024;
	const dm = decimals < 0 ? 0 : decimals;
	const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
	const i = Math.floor(Math.log(bytes) / Math.log(k));
	return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
};

// get local time from timeStamp
export const getLocalDateTime = (timeStamp) => {
	var timeZone = moment.tz.guess();
	const localTime = moment.utc(timeStamp).local().format('YYYY-MMM-DD h:mm A');
	const timeZoneAbbr = moment.tz(timeZone).zoneAbbr();
	return `${localTime} ${timeZoneAbbr}`;
};

// remove special characters except -,space and _ from tag.
export const sanitizeTag = (tag) => {
	return tag.replace(/[^a-zA-Z0-9-_\s]/g, '');
};

// Check if string has valid number.
export const isNumeric = (value) => {
	return /^-?\d+$/.test(value);
};
